import { render, staticRenderFns } from "./Approve-page.vue?vue&type=template&id=3466ae4f&scoped=true"
import script from "./Approve-page.vue?vue&type=script&lang=js"
export * from "./Approve-page.vue?vue&type=script&lang=js"
import style0 from "./Approve-page.vue?vue&type=style&index=0&id=3466ae4f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3466ae4f",
  null
  
)

export default component.exports